<template>
  <ul tab-list :data-len="len">
    <li ontouchstart="" class="item" :class="{on: (item.value === undefined ? item : item.value) === value}" v-for="item in listCreated" :key="item.value === undefined ? item : (item.value + item.label)" @click="change(item, true)"><s>{{ item.label || item }}</s></li>
    <li ontouchstart="" class="item" :class="{on: value === key}" v-for="(label, key) in obj" :key="key + label" @click="change({label, value: key}, true)"><s>{{ label }}</s></li>
  </ul>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'TabList',
  data() {
    return {
      selected: null,
    };
  },
  props: {
    value: { default: null },
    list: { type: Array, default: null },
    split: { type: String, default: null },
    obj: { default: null },
  },
  watch: {
    list: 'update',
    split: 'update',
    obj: 'update',
    value: 'update',
  },
  computed: {
    listCreated() {
      return this.split ? this.split.split(/[ ]*,[ ]*/) : this.list;
    },
    len() {
      return (this.listCreated ? this.listCreated.length : 0) + (this.obj ? Object.keys(this.obj).length : 0);
    },
  },
  methods: {
    change(val, artificial) {
      if (this.selected === val || (this.selected && this.selected.value !== undefined && this.selected.value === val.value)) return;
      this.selected = val;
      const v = !val || val.value === undefined ? val : val.value;
      this.$emit('input', v);
      if (artificial) this.$emit('change', v);
    },
    update() {
      let val;
      if (this.listCreated) {
        val = _.find(this.listCreated, item => (item.value || item) === this.value);
      } else if (this.obj) {
        val = this.obj[this.value] ? { label: this.obj[this.value], value: this.value } : null;
      }
      if (!val) {
        if (this.listCreated) {
          [val] = this.listCreated;
        } else if (this.obj) {
          _.forEach(this.obj, (label, value) => {
            if (!val) val = { label, value };
          });
        }
      }
      this.change(val);
    },
  },
}
</script>
<style lang="less">
@import "~@/less/proj";
.tab-list-col-loop(@i) when (@i > 0) {
  &[data-len="@{i}"] { .col-list(0,@i); }
  .tab-list-col-loop(@i - 1);
}

[tab-list] { .tab-list-col-loop(8);
  li { .fs(20); .h(50); .lh(50); .calibre; .medium; .tc; .pointer; color: #f7f8fb;
    s { .cal-m; }
    &.on { .bgc(#fff); color:#222; }
  }
}
</style>
